import { render, staticRenderFns } from "./page-layout-default.vue?vue&type=template&id=cf7c01f0&scoped=true&"
import script from "./page-layout-default.vue?vue&type=script&lang=js&"
export * from "./page-layout-default.vue?vue&type=script&lang=js&"
import style0 from "./page-layout-default.vue?vue&type=style&index=0&id=cf7c01f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7c01f0",
  null
  
)

export default component.exports